import { makeVar, useReactiveVar } from "@apollo/client";

export const videoPlayerVariable = makeVar<boolean>(false);

export const useVideoPlayerVariable = () => useReactiveVar(videoPlayerVariable);
